import React from 'react'
import image6 from "../img/Gruppe.JPG"
import DataList from "./data";

const Slide6 = () => {
    return (
        <div className="">
            <div className="container">
                <div class="head"></div>
                <div className="">
                <div className="image image6">
                    <img src={image6} alt=""></img>
                </div>
                </div>
                <div className="text scroll">
                    <div><DataList /></div>
                </div>
                <div id="myDiv" className="text num"></div>
                <div class="Footer"></div>
            </div>
        </div>
    )
}

export default Slide6;